export const devicetypeOptions = [
  { key: '1', text: 'KIOSK', value: 'KIOSK' },
  { key: '2', text: 'Fixed Reader', value: 'Fixed Reader' },
  { key: '3', text: 'LED Device', value: 'LED Device' },
  { key: '4', text: 'Server', value: 'Server' },
  { key: '5', text: 'Camera', value: 'Camera' },
  { key: '6', text: 'Hand Held Reader', value: 'Hand Held Reader' },
];
export const kiosk = [
  { key: '1', text: 'employment kiosks', value: 'employment kiosks' },
  { key: '2', text: 'foodservice kiosks', value: 'foodservice kiosks' },
  { key: '3', text: 'healthcare kiosks', value: 'healthcare kiosks' },
  { key: '4', text: 'Bitcoin kiosks', value: 'Bitcoin kiosks' },
  { key: '5', text: 'photo kiosks', value: 'photo kiosks' },
];
export const fixedReader = [
  { key: '1', text: 'GPS', value: 'GPS' },
  { key: '2', text: 'BarCode', value: 'BarCode' },
  { key: '3', text: 'QR Code', value: 'QR Code' },
  { key: '4', text: 'RFID Reader', value: 'RFID Reader' },
  { key: '5', text: 'NFC', value: 'NFC' },
  { key: '6', text: 'Bluetooth', value: 'Bluetooth' },
];
export const Led = [
  { key: '1', text: 'Dimmer Switches', value: 'Dimmer Switches' },
  { key: '2', text: 'Color LED', value: 'Color LED' },
  { key: '3', text: 'SMD LED', value: 'SMD LED' },
  { key: '4', text: 'Graphene LED', value: 'Graphene LED' },
  {
    key: '5',
    text: 'Traditional and Inorganic LEDs',
    value: 'Traditional and Inorganic LEDs',
  },
  { key: '6', text: 'Organic LED', value: 'Organic LED' },
];
export const server = [
  { key: '1', text: 'Web server', value: 'Web server' },
  { key: '2', text: 'Proxy server', value: 'Proxy server' },
  { key: '3', text: 'Application server', value: 'Application server' },
  { key: '4', text: 'File server', value: 'File server' },
  { key: '5', text: 'Database server', value: 'Database server' },
  { key: '6', text: 'Collaboration server', value: 'Collaboration server' },
];
export const camera = [
  { key: '1', text: 'DSLR Cameras', value: 'DSLR Cameras' },
  { key: '2', text: 'Mirrorless Cameras', value: 'Mirrorless Cameras' },
  { key: '3', text: 'Bridge Cameras', value: 'Bridge Cameras' },
  { key: '4', text: 'Compact Cameras', value: 'Compact Cameras' },
  { key: '5', text: 'Film Cameras', value: 'Film Cameras' },
  { key: '6', text: 'Medium Format Cameras', value: 'Medium Format Cameras' },
];
export const API = [
  { text: 'User Creation', value: '   User Creation' },
  { text: 'User Deletion', value: 'User Deletion' },
  { text: 'User Edit', value: 'User Edit' },
  { text: 'User/Role Assign', value: 'User/Role Assign' },
  { text: 'User/Role Change', value: 'User/Role Change' },
  { text: 'Asset Creation', value: 'Asset Creation' },
  { text: 'Asset Edit', value: 'Asset Edit' },
  { text: 'Asset Delete', value: 'Asset Delete' },
  { text: 'Asset/Workflow Assign', value: 'Asset/Workflow Assign' },
  { text: 'Asset/Workflow Change', value: ' Asset/Workflow Change' },
  { text: 'Asset/User Assign', value: 'Asset/User Assign' },
  { text: ' Asset/User Change', value: ' Asset/User Change' },
  {
    text: '  Asset/Schedule for Cleaning',
    value: '   Asset/Schedule for Cleaning',
  },
  { text: 'Asset/Ready for Movement', value: 'Asset/Ready for Movement' },
  { text: 'Asset/Picker Assigned', value: 'Asset/Picker Assigned' },
];
